<template>
  <d-container
    fluid
    class="main-content-container background d-flex align-items-center justify-content-center"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
          <div class="user_card p-4">
            <div class="d-flex justify-content-center">
              <div class="d-flex justify-content-center mt-3 login_container">
                <h2 class="mt-4">SERVI99</h2>
              </div>
            </div>

            <!-- Estado de permisos de ubicación -->
            <div class="d-flex justify-content-center mb-2">
              <div
                v-if="geolocationStatus === 'checking'"
                class="text-muted"
                style="font-size: 12px;"
              >
                Verificando ubicación...
              </div>
              <div
                v-else-if="geolocationStatus === 'granted'"
                class="text-success"
                style="font-size: 12px;"
              >
                ✅ Ubicación activa
              </div>
              <div
                v-else-if="['denied', 'blocked'].includes(geolocationStatus)"
                class="text-danger"
                style="font-size: 12px;"
              >
                ❌ Ubicación desactivada
                <button
                  type="button"
                  @click="checkpermisoUbicacion"
                  class="btn btn-sm btn-link p-0 ms-1"
                  style="font-size: 12px; vertical-align: baseline; text-decoration: underline;"
                >
                  Reintentar
                </button>
              </div>
              <div
                v-else-if="geolocationStatus === 'unsupported'"
                class="text-warning"
                style="font-size: 12px;"
              >
                ⚠️ Geolocalización no soportada
              </div>
              <div
                v-else-if="geolocationStatus === 'prompt'"
                class="text-info"
                style="font-size: 12px;"
              >
                ℹ️ Permiso pendiente
              </div>
            </div>

            <!-- Mensajes dinámicos -->
            <div
              v-if="showMessage"
              class="alert mx-4 text-center"
              :class="{
                'alert-danger': loginMessage.includes('Error') || loginMessage.includes('credenciales') || loginMessage.includes('coordenadas') || loginMessage.includes('incorrectas'),
                'alert-warning': loginMessage.includes('soporta') || loginMessage.includes('pendiente'),
                'alert-success': loginMessage.includes('éxito') || loginMessage.includes('reducción') || loginMessage.includes('BMGES')
              }"
              style="font-size: 13px; padding: 8px 12px; margin-bottom: 12px; border-radius: 4px;"
            >
              {{ loginMessage }}
            </div>
            <div
              v-if="loginMessageReduccion"
              class="alert mx-4 text-center"
              :class="{
                'alert-warning': loginMessageReduccion.includes('reducción')
              }"
              style="font-size: 12px; padding: 8px 12px; margin-bottom: 12px; border-radius: 4px;"
            >
              {{ loginMessageReduccion }}
            </div>

            <div class="form_container">
              <form @submit.prevent="Login()">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                  </div>
                  <input
                    required
                    type="text"
                    name="user"
                    id="user"
                    v-model="user"
                    class="form-control input_user"
                    placeholder="Usuario"
                  />
                </div>
                <div class="input-group mb-2">
                  <div class="input-group-append">
                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                  </div>
                  <input
                    required
                    type="password"
                    v-model="password"
                    id="password"
                    name="password"
                    class="form-control input_pass"
                    placeholder="Contraseña"
                  />
                </div>
                <div class="form-group">
                  <div class="custom-control custom-checkbox"></div>
                </div>
                <div class="d-flex justify-content-center mt-3 login_container">
                  <button
                    type="submit"
                    name="submit"
                    value="Iniciar Sesión"
                    class="btn login_btn"
                    :disabled="isLoading"
                  >
                    {{ isLoading ? 'Iniciando...' : 'Iniciar sesión' }}
                  </button>
                </div>
                <div class="text-center mt-2">
                  <span style="font-size: 10px !important">{{ version }}</span>
                </div>
                <div class="d-flex justify-content-center mt-1 login_container">
                  <span style="font-size: 8px">V 25112025</span>
                </div>
                <div
                  v-if="geolocationStatus === 'granted' && distancia !== ''"
                  class="d-flex justify-content-center mt-1 login_container"
                >
                  <span style="font-size: 8px">{{ parseFloat(distancia).toFixed(2) }} km</span>
                </div>
              </form>
            </div>
            <div class="mt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </d-container>
</template>

<script>
import api from "../config/api";

async function calcularDistancia(lat1, lon1, lat2, lon2) {
  return new Promise((resolve, reject) => {
    const lat1Num = parseFloat(lat1);
    const lon1Num = parseFloat(lon1);
    const lat2Num = parseFloat(lat2);
    const lon2Num = parseFloat(lon2);

    if (
      isNaN(lat1Num) ||
      isNaN(lon1Num) ||
      isNaN(lat2Num) ||
      isNaN(lon2Num)
    ) {
      reject(new Error("Coordenadas inválidas"));
    }

    const R = 6371;
    const dLat = (lat2Num - lat1Num) * Math.PI / 180;
    const dLon = (lon2Num - lon1Num) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1Num * Math.PI / 180) *
        Math.cos(lat2Num * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distancia = R * c;
    resolve(distancia);
  });
}

export default {
  name: "Login",
  data() {
    return {
      user: "",
      password: "",
      version: "",
      misCoordenadas: "",
      distancia: "",
      geolocationStatus: "idle",
      loginMessage: "",
      loginMessageReduccion: "",
      showMessage: false,
      isLoading: false
    };
  },
  mounted() {
    this.version = localStorage.getItem("version") || "";
    this.updateGeolocationStatus();
  },
  methods: {
    async updateGeolocationStatus() {
      if (!navigator.geolocation) {
        this.geolocationStatus = "unsupported";
        return;
      }
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const permStatus = await navigator.permissions.query({ name: "geolocation" });
          this.geolocationStatus = permStatus.state;
        } else {
          this.geolocationStatus = "prompt";
        }
      } catch (err) {
        console.warn("Permissions API no disponible", err);
        this.geolocationStatus = "prompt";
      }
    },

    async checkpermisoUbicacion() {
      this.showMessage = false;

      if (!navigator.geolocation) {
        this.geolocationStatus = "unsupported";
        return false;
      }

      try {
        if (navigator.permissions && navigator.permissions.query) {
          const perm = await navigator.permissions.query({ name: "geolocation" });
          if (perm.state === "granted") {
            return await new Promise((resolve) => {
              navigator.geolocation.getCurrentPosition(
                (pos) => {
                  this.misCoordenadas = `${pos.coords.latitude}, ${pos.coords.longitude}`;
                  this.geolocationStatus = "granted";
                  resolve(true);
                },
                () => {
                  this.geolocationStatus = "denied";
                  resolve(false);
                },
                { timeout: 8000, maximumAge: 30000 }
              );
            });
          } else if (perm.state === "denied") {
            this.geolocationStatus = "denied";
            return false;
          }
        }

        this.geolocationStatus = "checking";
        return await new Promise((resolve) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              this.misCoordenadas = `${pos.coords.latitude}, ${pos.coords.longitude}`;
              this.geolocationStatus = "granted";
              resolve(true);
            },
            () => {
              this.geolocationStatus = "denied";
              resolve(false);
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
          );
        });
      } catch (err) {
        console.error("Error en checkpermisoUbicacion:", err);
        this.geolocationStatus = "denied";
        return false;
      }
    },

    async Login() {
      this.showMessage = false;
      this.isLoading = true;
      this.loginMessageReduccion = "";
      const data = {
        webuser: this.user,
        webpw: this.password
      };

      try {
        const response = await api.request("post", "/loginFromApp", data);
        console.log("RESPONSE--->", response);

        if ((response.status === 200 && response.data.length > 0) || response.data.login) {
          if (response.data.login) {
            const coord1 = response.data.latLng;

            if (coord1 && coord1.trim() !== "") {
              const tienePermiso = await this.checkpermisoUbicacion();

              if (!tienePermiso || !this.misCoordenadas || this.misCoordenadas.trim() === "") {
                this.isLoading = false;
                this.loginMessage = "No se pudieron obtener tus coordenadas. Se requiere acceso a la ubicación.";
                this.showMessage = true;
                return;
              }

              const [lat1, lon1] = coord1.split(",").map(x => x.trim());
              const [lat2, lon2] = this.misCoordenadas.split(",").map(x => x.trim());

              try {
                this.distancia = await calcularDistancia(lat1, lon1, lat2, lon2);
                const metros = (this.distancia * 1000).toFixed(2);
                console.log("Distancia:", metros, "mts");

                if (Number(metros) > 200) {
                  this.loginMessageReduccion = `Distancia: ${metros} mts. Se aplicará reducción de horas.`;
                  this.showMessage = true;

                  const dataQueja = {
                    subcon: 0,
                    usuario: this.user.toUpperCase(),
                    descripcion: `REDUCC. HORAS X FICHAJE DISTANCIA: ${metros} mts.`
                  };
                  await api.request("post", "/ingresarQuejaYreduccionHoras", dataQueja);
                }

                const dataCoordenadas = {
                  latLng: this.misCoordenadas,
                  usuario: this.user.toUpperCase(),
                  distancia: this.distancia.toFixed(2)
                };

                console.log('loginBmges');
                let resLoginBmges = await api.request("post", "/loginBmges", data);
                console.log('resLoginBmges', resLoginBmges);
                await api.request("post", "/guardarCoordenadasbMGES", dataCoordenadas);

                this.loginMessage = "Inicio de sesión exitoso en BMGES.";
                this.showMessage = true;
              } catch (error) {
                console.error("Error al calcular distancia:", error);
                this.loginMessage = "Error al procesar la ubicación. Verifica tu conexión.";
                this.showMessage = true;
              }
            } else {
              this.loginMessage = "Faltan coordenadas en la ficha del subcontratista.";
              this.showMessage = true;
            }
          } else {
            const user = response.data[0];
            localStorage.setItem("rolUser", 1);
            localStorage.setItem("usuarioId", user.numero);
            localStorage.setItem("user", JSON.stringify(user));
            this.$router.push("/admin/home");
            this.isLoading = false;
            return;
          }
        } else {
          this.loginMessage = "Credenciales incorrectas. Inténtalo nuevamente.";
          this.showMessage = true;
        }
      } catch (error) {
        console.error("Error en login:", error);
        this.loginMessage = "Credenciales incorrectas. Por favor inténtalo nuevamente.";
        this.showMessage = true;
      }

      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.background {
  background-image: url("../assets/images/background.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height: 100vh;
  width: 100%;
}

.user_card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 100%;
}

.login_btn {
  background-color: #007bff;
  color: white;
  border: none;
  width: 100%;
}

.login_btn:hover:not(:disabled) {
  background-color: #0056b3;
}

.login_btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>